export default {
    formSubmitEndpoint: 'https://formspree.io/f/mknkgpqp',
};
